const SURFACE_BY_KEY = { duplicate: 'duplicate', evidence: 'evidence' }

// A plain transaction has no review surface, so it is never "next".
export const reviewFor = (transaction) => {
  const key = Object.keys(SURFACE_BY_KEY).find((name) => transaction?.[name])
  if (!key) return null

  const finding = transaction[key]
  const analytic = (transaction.analytics || []).find((entry) => entry.id === finding.analytic_id) || {
    id: finding.analytic_id,
    name: finding.analytic_name
  }
  return { transaction, analytic, surface: SURFACE_BY_KEY[key] }
}

const isUndecided = (transaction) => !transaction.review || transaction.review.status === 'Open'

// Forward only. `decidedIds` covers every side of a duplicate, which the list
// still shows as Open until it refetches.
export const nextReview = (transactions, currentId, decidedIds = []) => {
  const start = transactions.findIndex((transaction) => transaction.id === currentId)
  return transactions
    .slice(start + 1)
    .filter((transaction) => !decidedIds.includes(transaction.id))
    .filter(isUndecided)
    .map(reviewFor)
    .find(Boolean) || null
}
